import React, { FC, Fragment, ReactElement, ReactNode, useEffect, useMemo, useState } from 'react';
import { Colors, FlexBox, Skeleton, useBreakpoint, useIsMobile } from '@brg/ui';
import { ProjectsGridNew } from '../../components/grids';
import styled, { useTheme, css, ThemeProvider } from 'styled-components';
import { API, CardAPI, Endpoints, Lang, LangObject, Tag } from '@brg/api';
import { CoreContainer, LayoutConst } from '../../../core';
import { ProjectControllerWrapper } from "../explore/styles";
import { HSESansTitleCoolEpicMegoGena } from '_deziiign/hsedesign/components/IndexTitle';
import { AppTester, getCurrentContextName } from "../../../supporting";
import { ContextViewWithCard } from 'shared/components/ContextView/ContextViewWithCard';
import { tagPageCategories } from './components/TagPageSwitcher';
import { useSelector } from 'react-redux';
import { TagPageSelector } from 'shared/reducers/TagPageSlice';
import { IqmediaSubscribeButton } from '../designer/components/subscribe/IqmediaSubscribeButton';
import { TagsContainer } from './components/styles';
import { TagDescriptionComponent } from './components/TagDescriptionComponent';
import { ShowMoreWithTags } from 'shared/components/ShowMoreWithTags/ShowMoreWithTags';
import { Button } from '@brg/ui';
import ReactShowMoreText from 'react-show-more-text';
import { useLocation } from 'react-router-dom';
import CustomShowMore from './components/CustomShowMore';
import { useTranslation } from 'react-i18next';
import { CustomBgWrapper } from 'shared/components/CustomBgWrapper/CustomBgWrapper';
import { createThemeByColor } from 'shared/helpers/coloring';

export const ShowMore = styled.span`
  cursor: pointer;
  color: ${p => p.theme.designerPage.noProjectBlock.avatar.bg};
    &:hover {
      color: ${({ theme }) => theme?.navigationBar?.btns?.showMore?.hover?.color || Colors.geoWhite47};
      transition: color 0.2s;

`;

const ProjectWrapper = styled(ProjectControllerWrapper)`
  margin-top: 24px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 16px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-bottom: 32px !important;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: 0px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: 24px !important;
  }

`;

export const Container = styled(CoreContainer)`
  .search-bar-wrapper {
    max-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    .grid-w {
      padding-top: 16px;
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    .grid-w {
      padding-top: 0px;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
    align-items: flex-start;

    & > :last-child {
      margin-top: 24px;
      width: 100%;
    }
  }
`;

interface ContextDesc {
  appName: string;
  context: string;
  description: LangObject[];
  position: number;
}

interface Description {
  descriptionType: number;
  contexts: Array<{
    appName: string;
    context: string;
  }>;
  position: number;
  description: LangObject[];
  dateCreate: string;
  dateUpdate: string;
}

type TagWithContext = Tag<'Global'> & {
  contextDescriptions?: ContextDesc[];
  descriptions?: Description[];
};

export interface TagViewLayoutProps {
  theme?: any;
  bgColor?: string;
  isLoading?: boolean;
  isTagsLoading?: boolean;
  isTagOwnerOrModer?: boolean;
  title?: ReactNode;
  filtersContent?: ReactNode;
  tagAdminFiltersContent?: ReactNode;
  projectsContent?: ReactNode;
  openLikeCtx?: boolean;
  description?: string;
  tagCard?: any;
  tagTabsContent?: ReactNode;
  id?: string;
  tagsContent?: string[] | undefined | any[];
  headerContent?: ReactNode;
}
const VISIBLE_COUNT = 8;

export const TagViewLayout: FC<TagViewLayoutProps> = (props) => {
  const { isLoading, isTagsLoading, description, isTagOwnerOrModer, tagCard, tagTabsContent, title, projectsContent, filtersContent, tagAdminFiltersContent, openLikeCtx, id, tagsContent = [], headerContent } = props;
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const { theme, bgColor } = props;
  const is733 = useBreakpoint(LayoutConst.screen.s - 1);
  const isMobile = useIsMobile();
  const isMedia = AppTester.isMediiia();
  const isIqMediia = AppTester.isIqMediiia();
  const isGeograffee = AppTester.isGeograffee();
  const isSuperPupper = AppTester.isSuperPuper();
  const isDafes = AppTester.isGeoDafes();
  const isCGrave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isFtbl = AppTester.isFtbl();
  const location = useLocation();
  const { currentCategory } = useSelector(TagPageSelector);
  const [showAllTags, setShowAllTags] = useState(false);
  const { t, i18n } = useTranslation();
  const visibleTags = useMemo(() => {
    return showAllTags ? tagsContent : tagsContent.slice(0, VISIBLE_COUNT);
  }, [tagsContent, showAllTags, location.pathname]);

  useEffect(() => {
    if (!isTagsLoading && tagsContent.length <= VISIBLE_COUNT) {
      setShowAllTags(false);
    }
  }, [tagsContent, isTagsLoading]);

  useEffect(() => {
    setShowAllTags(false);
  }, [location.pathname]);

  const [refresh, setRefresh] = useState(0);
  const [tagData, setTagData] = useState<TagWithContext>();

  useEffect(() => {
    if (!id) return;

    API.request()
      .endpoint(Endpoints.tagsMnePw)
      .url('/api/Tags/GetTag')
      .addQuery('idTag', id)
      .addQuery('isIgnoreCanonical', 'true')
      .get()
      .send()
      .then(r => r.json() as Promise<TagWithContext>)
      .then((data: TagWithContext) => {
        setTagData(data);
      })
      .catch(err => {
        console.error('Fetch error:', err);
      });
  }, [id, refresh]);

  const currentContext = getCurrentContextName();
  const wanted = currentContext?.toLowerCase();

  const ctxDescArr = useMemo(() => {
    if (!wanted) return [];

    const findDesc = (context: string, position?: number) => {
      const contextDesc = tagData?.contextDescriptions?.find(cd =>
        cd.context?.trim() &&
        cd.context?.toLowerCase().split(',').map(c => c.trim()).includes(context) &&
        cd.description?.length
      )?.description;

      if (contextDesc) return contextDesc;

      const specificDesc = tagData?.descriptions?.find(d =>
        d.description?.length &&
        (!position || d.position === position) &&
        d.contexts?.some(ctx => ctx.context?.toLowerCase().split(',').map(c => c.trim()).includes(context))
      )?.description;

      if (specificDesc) return specificDesc;

      return tagData?.descriptions?.find(d =>
        d.description?.length &&
        (!position || d.position === position) &&
        d.contexts?.some(ctx => ctx.context?.toLowerCase().split(',').map(c => c.trim()).includes('general'))
      )?.description;
    };

    return findDesc(wanted, 1) || [];
  }, [wanted, tagData]);

  const getTextByLanguage = (langArray: any[], targetLang: string): string => {
    if (!langArray || langArray.length === 0) return '';

    let text = langArray.find(item => item.lang?.toLowerCase() === targetLang.toLowerCase())?.name;

    if (!text) {
      text = langArray.find(item => item.lang?.toLowerCase() === 'en')?.name;
    }

    if (!text && langArray.length > 0) {
      text = langArray[0].name;
    }

    return text || '';
  };

  const ctxText = ctxDescArr.length
    ? getTextByLanguage(ctxDescArr, i18n.language)
    : '';

  const isCompetitionCategory = useMemo(
    () => ([tagPageCategories.competitions]?.includes(currentCategory)), [currentCategory])

  if (openLikeCtx) {
    return (
      <ContextViewWithCard
        description={description}
        title={title}
        tag={tagData}
        tabs={!isMobile && tagTabsContent}
        filters={filtersContent}
        isLoading={isLoading}
      />
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <CustomBgWrapper backgroundColor={bgColor}>
        <Container>
          <>
            {headerContent}
            {isIqMediia && !headerContent ? (
              <TitleWrapper>
                <HSESansTitleCoolEpicMegoGena
                  isAlumni
                  isDark={
                    ((isGeograffee || isCompetitionCategory) && !isDafes) ||
                    isSuperPupper || isAdcrDafesNet
                  }
                  isTagPage
                >
                  {isLoading ? (
                    <FlexBox gy={16} gyMobile={32} direction='column' directionMobile={'column'}>
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={600}
                        height={70}
                      />
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={isMobile ? '50%' : 600}
                        height={24}
                      />
                    </FlexBox>
                  ) : (
                    title
                  )}
                </HSESansTitleCoolEpicMegoGena>
                <FlexBox width={is733 ? "100%" : 270}>
                  <IqmediaSubscribeButton designerId={id || ""} targetType="tag" />
                </FlexBox>
              </TitleWrapper>
            ) : (
              <>
                {!headerContent
                  && !isTagsLoading
                  && tagsContent.length > 0
                  && visibleTags.length > 0
                  && (
                    <TagsContainer isFtbl={isFtbl}>
                      {visibleTags.map((t, i) => <Fragment key={i}>{t}</Fragment>)}
                      {tagsContent.length > VISIBLE_COUNT && (
                        <ShowMore onClick={() => setShowAllTags(v => !v)}>
                          {showAllTags ? t('show_less_text') : t('show_more_text')}
                        </ShowMore>
                      )}
                    </TagsContainer>
                  )}
                {!headerContent && (
                <HSESansTitleCoolEpicMegoGena
                  isAlumni
                  isDark={
                    ((isGeograffee || isCompetitionCategory || isCGrave || isAdcrDafesNet || isContinuumSite || isGameDeziiign) && !isDafes) ||
                    isSuperPupper
                  }
                  isTagPage
                >
                  {isLoading ? (
                    <FlexBox gy={16} gyMobile={32} direction='column' directionMobile={'column'}>
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={600}
                        height={70}
                      />
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={isMobile ? '50%' : 600}
                        height={24}
                      />
                    </FlexBox>
                  ) : (
                    title
                  )}
                </HSESansTitleCoolEpicMegoGena>
                )}
              </>
            )}
            {!headerContent && (
              <TagDescriptionComponent tagId={id ?? ''} refresh={refresh} onSaved={() => setRefresh(k => k + 1)} />
            )}
            {!headerContent && !isLoading && (
              <FlexBox align="center" style={{ ...(isTagOwnerOrModer && !is992 && { width: '100%' }) }}>{tagAdminFiltersContent}</FlexBox>
            )}
          </>
          {filtersContent}
          <ProjectWrapper>{isLoading && currentCategory === 'competitions' ? <ProjectsGridNew isLoading={true} /> : projectsContent}</ProjectWrapper>

          {/* Второе описание */}

          {ctxText && (
            <FlexBox
              direction="column"
              style={{ maxWidth: 858 }}
              offsetTop={32}
              offsetTopMobile={24}
              offsetBottom={16}
              offsetBottomMobile={16}
            >
              <CustomShowMore
                text={ctxText}
                maxLines={6}
                isDark={isGeograffee || isCompetitionCategory}
              />
            </FlexBox>
          )}

        </Container>
      </CustomBgWrapper>
    </ThemeProvider>
  );
};import React, { FC, Fragment, ReactElement, ReactNode, useEffect, useMemo, useState } from 'react';
import { Colors, FlexBox, Skeleton, useBreakpoint, useIsMobile } from '@brg/ui';
import { ProjectsGridNew } from '../../components/grids';
import styled, { useTheme, css, ThemeProvider } from 'styled-components';
import { API, CardAPI, Endpoints, Lang, LangObject, Tag } from '@brg/api';
import { CoreContainer, LayoutConst } from '../../../core';
import { ProjectControllerWrapper } from "../explore/styles";
import { HSESansTitleCoolEpicMegoGena } from '_deziiign/hsedesign/components/IndexTitle';
import { AppTester, getCurrentContextName } from "../../../supporting";
import { ContextViewWithCard } from 'shared/components/ContextView/ContextViewWithCard';
import { tagPageCategories } from './components/TagPageSwitcher';
import { useSelector } from 'react-redux';
import { TagPageSelector } from 'shared/reducers/TagPageSlice';
import { IqmediaSubscribeButton } from '../designer/components/subscribe/IqmediaSubscribeButton';
import { TagsContainer } from './components/styles';
import { TagDescriptionComponent } from './components/TagDescriptionComponent';
import { ShowMoreWithTags } from 'shared/components/ShowMoreWithTags/ShowMoreWithTags';
import { Button } from '@brg/ui';
import ReactShowMoreText from 'react-show-more-text';
import { useLocation } from 'react-router-dom';
import CustomShowMore from './components/CustomShowMore';
import { useTranslation } from 'react-i18next';
import { CustomBgWrapper } from 'shared/components/CustomBgWrapper/CustomBgWrapper';
import { createThemeByColor } from 'shared/helpers/coloring';

export const ShowMore = styled.span`
  cursor: pointer;
  color: ${p => p.theme.designerPage.noProjectBlock.avatar.bg};
    &:hover {
      color: ${({ theme }) => theme?.navigationBar?.btns?.showMore?.hover?.color || Colors.geoWhite47};
      transition: color 0.2s;

`;

const ProjectWrapper = styled(ProjectControllerWrapper)`
  margin-top: 24px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 16px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-bottom: 32px !important;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: 0px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: 24px !important;
  }

`;

export const Container = styled(CoreContainer)`
  .search-bar-wrapper {
    max-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    .grid-w {
      padding-top: 16px;
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    .grid-w {
      padding-top: 0px;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
    align-items: flex-start;

    & > :last-child {
      margin-top: 24px;
      width: 100%;
    }
  }
`;

interface ContextDesc {
  appName: string;
  context: string;
  description: LangObject[];
  position: number;
}

interface Description {
  descriptionType: number;
  contexts: Array<{
    appName: string;
    context: string;
  }>;
  position: number;
  description: LangObject[];
  dateCreate: string;
  dateUpdate: string;
}

type TagWithContext = Tag<'Global'> & {
  contextDescriptions?: ContextDesc[];
  descriptions?: Description[];
};

export interface TagViewLayoutProps {
  theme?: any;
  bgColor?: string;
  isLoading?: boolean;
  isTagsLoading?: boolean;
  isTagOwnerOrModer?: boolean;
  title?: ReactNode;
  filtersContent?: ReactNode;
  tagAdminFiltersContent?: ReactNode;
  projectsContent?: ReactNode;
  openLikeCtx?: boolean;
  description?: string;
  tagCard?: any;
  tagTabsContent?: ReactNode;
  id?: string;
  tagsContent?: string[] | undefined | any[];
  headerContent?: ReactNode;
}
const VISIBLE_COUNT = 8;

export const TagViewLayout: FC<TagViewLayoutProps> = (props) => {
  const { isLoading, isTagsLoading, description, isTagOwnerOrModer, tagCard, tagTabsContent, title, projectsContent, filtersContent, tagAdminFiltersContent, openLikeCtx, id, tagsContent = [], headerContent } = props;
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const { theme, bgColor } = props;
  const is733 = useBreakpoint(LayoutConst.screen.s - 1);
  const isMobile = useIsMobile();
  const isMedia = AppTester.isMediiia();
  const isIqMediia = AppTester.isIqMediiia();
  const isGeograffee = AppTester.isGeograffee();
  const isSuperPupper = AppTester.isSuperPuper();
  const isDafes = AppTester.isGeoDafes();
  const isCGrave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isFtbl = AppTester.isFtbl();
  const location = useLocation();
  const { currentCategory } = useSelector(TagPageSelector);
  const [showAllTags, setShowAllTags] = useState(false);
  const { t, i18n } = useTranslation();
  const visibleTags = useMemo(() => {
    return showAllTags ? tagsContent : tagsContent.slice(0, VISIBLE_COUNT);
  }, [tagsContent, showAllTags, location.pathname]);

  useEffect(() => {
    if (!isTagsLoading && tagsContent.length <= VISIBLE_COUNT) {
      setShowAllTags(false);
    }
  }, [tagsContent, isTagsLoading]);

  useEffect(() => {
    setShowAllTags(false);
  }, [location.pathname]);

  const [refresh, setRefresh] = useState(0);
  const [tagData, setTagData] = useState<TagWithContext>();

  useEffect(() => {
    if (!id) return;

    API.request()
      .endpoint(Endpoints.tagsMnePw)
      .url('/api/Tags/GetTag')
      .addQuery('idTag', id)
      .addQuery('isIgnoreCanonical', 'true')
      .get()
      .send()
      .then(r => r.json() as Promise<TagWithContext>)
      .then((data: TagWithContext) => {
        setTagData(data);
      })
      .catch(err => {
        console.error('Fetch error:', err);
      });
  }, [id, refresh]);

  const currentContext = getCurrentContextName();
  const wanted = currentContext?.toLowerCase();

  const ctxDescArr = useMemo(() => {
    if (!wanted) return [];

    const findDesc = (context: string, position?: number) => {
      const contextDesc = tagData?.contextDescriptions?.find(cd =>
        cd.context?.trim() &&
        cd.context?.toLowerCase().split(',').map(c => c.trim()).includes(context) &&
        cd.description?.length
      )?.description;

      if (contextDesc) return contextDesc;

      const specificDesc = tagData?.descriptions?.find(d =>
        d.description?.length &&
        (!position || d.position === position) &&
        d.contexts?.some(ctx => ctx.context?.toLowerCase().split(',').map(c => c.trim()).includes(context))
      )?.description;

      if (specificDesc) return specificDesc;

      return tagData?.descriptions?.find(d =>
        d.description?.length &&
        (!position || d.position === position) &&
        d.contexts?.some(ctx => ctx.context?.toLowerCase().split(',').map(c => c.trim()).includes('general'))
      )?.description;
    };

    return findDesc(wanted, 1) || [];
  }, [wanted, tagData]);

  const getTextByLanguage = (langArray: any[], targetLang: string): string => {
    if (!langArray || langArray.length === 0) return '';

    let text = langArray.find(item => item.lang?.toLowerCase() === targetLang.toLowerCase())?.name;

    if (!text) {
      text = langArray.find(item => item.lang?.toLowerCase() === 'en')?.name;
    }

    if (!text && langArray.length > 0) {
      text = langArray[0].name;
    }

    return text || '';
  };

  const ctxText = ctxDescArr.length
    ? getTextByLanguage(ctxDescArr, i18n.language)
    : '';

  const isCompetitionCategory = useMemo(
    () => ([tagPageCategories.competitions]?.includes(currentCategory)), [currentCategory])

  if (openLikeCtx) {
    return (
      <ContextViewWithCard
        description={description}
        title={title}
        tag={tagData}
        tabs={!isMobile && tagTabsContent}
        filters={filtersContent}
        isLoading={isLoading}
      />
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <CustomBgWrapper backgroundColor={bgColor}>
        <Container>
          <>
            {headerContent}
            {isIqMediia && !headerContent ? (
              <TitleWrapper>
                <HSESansTitleCoolEpicMegoGena
                  isAlumni
                  isDark={
                    ((isGeograffee || isCompetitionCategory) && !isDafes) ||
                    isSuperPupper || isAdcrDafesNet
                  }
                  isTagPage
                >
                  {isLoading ? (
                    <FlexBox gy={16} gyMobile={32} direction='column' directionMobile={'column'}>
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={600}
                        height={70}
                      />
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={isMobile ? '50%' : 600}
                        height={24}
                      />
                    </FlexBox>
                  ) : (
                    title
                  )}
                </HSESansTitleCoolEpicMegoGena>
                <FlexBox width={is733 ? "100%" : 270}>
                  <IqmediaSubscribeButton designerId={id || ""} targetType="tag" />
                </FlexBox>
              </TitleWrapper>
            ) : (
              <>
                {!headerContent
                  && !isTagsLoading
                  && tagsContent.length > 0
                  && visibleTags.length > 0
                  && (
                    <TagsContainer isFtbl={isFtbl}>
                      {visibleTags.map((t, i) => <Fragment key={i}>{t}</Fragment>)}
                      {tagsContent.length > VISIBLE_COUNT && (
                        <ShowMore onClick={() => setShowAllTags(v => !v)}>
                          {showAllTags ? t('show_less_text') : t('show_more_text')}
                        </ShowMore>
                      )}
                    </TagsContainer>
                  )}
                {!headerContent && (
                <HSESansTitleCoolEpicMegoGena
                  isAlumni
                  isDark={
                    ((isGeograffee || isCompetitionCategory || isCGrave || isAdcrDafesNet || isContinuumSite || isGameDeziiign) && !isDafes) ||
                    isSuperPupper
                  }
                  isTagPage
                >
                  {isLoading ? (
                    <FlexBox gy={16} gyMobile={32} direction='column' directionMobile={'column'}>
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={600}
                        height={70}
                      />
                      <Skeleton
                        style={{
                          backgroundColor: theme.skeleton.skeletonBgColor,
                        }}
                        width={isMobile ? '50%' : 600}
                        height={24}
                      />
                    </FlexBox>
                  ) : (
                    title
                  )}
                </HSESansTitleCoolEpicMegoGena>
                )}
              </>
            )}
            {!headerContent && (
              <TagDescriptionComponent tagId={id ?? ''} refresh={refresh} onSaved={() => setRefresh(k => k + 1)} />
            )}
            {!headerContent && !isLoading && (
              <FlexBox align="center" style={{ ...(isTagOwnerOrModer && !is992 && { width: '100%' }) }}>{tagAdminFiltersContent}</FlexBox>
            )}
          </>
          {filtersContent}
          <ProjectWrapper>{isLoading && currentCategory === 'competitions' ? <ProjectsGridNew isLoading={true} /> : projectsContent}</ProjectWrapper>

          {/* Второе описание */}

          {ctxText && (
            <FlexBox
              direction="column"
              style={{ maxWidth: 858 }}
              offsetTop={32}
              offsetTopMobile={24}
              offsetBottom={16}
              offsetBottomMobile={16}
            >
              <CustomShowMore
                text={ctxText}
                maxLines={6}
                isDark={isGeograffee || isCompetitionCategory}
              />
            </FlexBox>
          )}

        </Container>
      </CustomBgWrapper>
    </ThemeProvider>
  );
};